import { useLocation } from 'react-router-dom';

export const useCurrentRoute = () => {
  const { pathname, search: queryString } = useLocation();

  return `${pathname}${queryString}`;
};
